export const ALGOLIA_APP_ID = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!
export const ALGOLIA_API_KEY_SEARCH =
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY_SEARCH!
export const ALGOLIA_INDEX_NAME_NEWS =
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_NEWS!
export const ALGOLIA_INDEX_NAME_LEXICON =
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_LEXICON!
export const ALGOLIA_API_KEY_ADMIN = process.env.ALGOLIA_API_KEY_ADMIN!
export const ALGOLIA_UPDATE_SECRET = process.env.ALGOLIA_UPDATE_SECRET!
